module.exports = __webpack_public_path__ + "assets/3a1d9bf906e32451eeae8e474005ce74.svg";